import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSourceFilter } from './useSourceFilter';

export const SourceFilter = ({ value, setFilters, sourceOptions }) => {
  const { formSchema, onSubmit } = useSourceFilter({
    setFilters,
  });

  const selectedOption = sourceOptions.find((i) => i.value === value) ?? sourceOptions[0];

  return (
    <Formik
      initialValues={{ source: selectedOption || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="source"
          placeholder="Source"
          size="small"
          component={FormSelect}
          options={sourceOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SourceFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  sourceOptions: PropTypes.array.isRequired,
};

SourceFilter.defaultProps = {
  value: '',
};
